import { Injectable, Inject } from '@angular/core';
import { switchMap, tap, map } from 'rxjs/operators';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { ActionTypes, Actions as dataActions } from './actions';
import { AUTH_SERVICE, AuthenticationService } from '@awp/http';

@Injectable()
export class DataEffects {

  constructor(
    private actions$: Actions<dataActions>,
    @Inject(AUTH_SERVICE) private authService: AuthenticationService) { }

  auth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionTypes.AUTHENTICATE),
      switchMap(() => {
        this.authService.setAuthResponse(); // clear previously cached response
        return this.authService.authenticate()
          .pipe(
            tap(response => {
              this.authService.setAuthResponse(response);
            })
          );
      })
    ),
    { dispatch: false }
  );

}
